import { useExampleStore } from "./useExampleStore";
import { usePermissionStore } from "./usePermissionStore";
import { useAuthStore } from "./authStore";
import { useSelectDistributor } from "./selectDistributorStore";

export const resetAllStores = () => {
  useExampleStore.getState().reset?.();
  usePermissionStore.getState().reset?.();
  useAuthStore.getState().clearUser?.();
  useSelectDistributor.getState().reset?.();
};
